import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule }
	from '@angular/material/dialog';
import moment from 'moment';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { FocusMeDirective } from '../../../shared/directives/focus-me.directive';

interface BatchReference {
	reference: string;
	qty: number;
	modificationDate: Date;
}

@Component({
	selector: 'copo-claim-confirmation-dialog',
	templateUrl: './claim-confirmation-dialog.component.html',
	styleUrl: './claim-confirmation-dialog.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, NgIf, MatButtonModule, FocusMeDirective, MatDialogModule]
})
export class ClaimConfirmationDialogComponent {
	claimedBatch: string | undefined;
	claimedModificationDate: string | undefined;
	constructor(

		public dialogRef: MatDialogRef<ClaimConfirmationDialogComponent>,

		@Inject(MAT_DIALOG_DATA) public data: BatchReference[]
	) {
		this.claimedBatch = data.map(reference => reference.reference).join(', ');
		this.claimedModificationDate = data
			.map(reference => moment(reference.modificationDate).format('DD/MM/YYYY'))
			.join(', ');
	}

	claimSubmit(event: boolean) {
		this.dialogRef.close(event);
	}
}
